import styled from "styled-components";

export const Container = styled.div`
  .leaflet-container {
    width: 100%;
    height: 100vh;
  }

  .Details {
    margin: 10px 0px;
    color: blue;
    cursor: pointer;
  }
`;
